export default {
  DOG: 'DOG',
  CAT: 'CAT',
  UNKNOWN: 'UNKNOWN'
}
